import { memo } from 'react';
import { Card, ProgressBar, Spinner } from 'react-bootstrap';

import type { OrganizationStats } from '@/types';

import styles from './StatsWidget.module.scss';

interface StatsWidgetProps {
  readonly stats: OrganizationStats | null;
  readonly loading?: boolean;
}

function formatNumber(num: number): string {
  return num.toLocaleString();
}

export const StatsWidget = memo<StatsWidgetProps>(function StatsWidget({
  stats,
  loading,
}) {
  if (loading) {
    return (
      <Card className={styles.statsCard}>
        <Card.Body className={styles.loadingBody}>
          <Spinner size="sm" animation="border" />
          <span>Loading statistics...</span>
        </Card.Body>
      </Card>
    );
  }

  if (!stats) {
    return null;
  }

  return (
    <Card className={styles.statsCard}>
      <Card.Body>
        <div className={styles.statsGrid}>
          <div className={styles.statItem}>
            <div className={styles.statValue}>
              {formatNumber(stats.total_organizations)}
            </div>
            <div className={styles.statLabel}>Organizations</div>
          </div>

          <div className={styles.statItem}>
            <div className={styles.statValue}>
              {formatNumber(stats.assigned_facilities)}
            </div>
            <div className={styles.statLabel}>Grouped Facilities</div>
          </div>

          <div className={styles.statItem}>
            <div className={styles.statValue}>
              {formatNumber(stats.total_facilities)}
            </div>
            <div className={styles.statLabel}>Total Facilities</div>
          </div>

          <div className={styles.coverageItem}>
            <div className={styles.coverageHeader}>
              <span className={styles.coverageLabel}>Coverage</span>
              <span className={styles.coverageValue}>
                {stats.coverage_percentage.toFixed(1)}%
              </span>
            </div>
            <ProgressBar
              now={stats.coverage_percentage}
              variant="primary"
              className={styles.progressBar}
            />
          </div>
        </div>
      </Card.Body>
    </Card>
  );
});
